import AngleRight from "@icons/angle-right.svg?react";

import { trackMarketplaceItemClick } from "@/common/components/mixpanel/mixpanel-tracking";
import { SearchParamsLink } from "@/common/components/search-params-link/search-params-link";

const NavigationCard = ({
  badge,
  disabled = false,
  icon,
  label,
  to,
  id,
}: {
  badge?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
  label: string;
  to: string;
  id: string;
}) => {
  const cardContent = (
    <h2
      className={`font-bold text-xl flex gap-4 items-center w-full shadow-[2px_4px_16px_0px_rgba(122,128,147,0.35)] p-4 rounded-2xl ${
        disabled
          ? "text-gray-400 cursor-not-allowed"
          : "text-can-midnight-steel"
      }`}
    >
      {icon}
      <span>{label}</span>
      {badge ? (
        <span className="text-sm ml-auto font-normal text-gray-500">
          {badge}
        </span>
      ) : null}
      {!disabled ? (
        <AngleRight className="w-6 h-6 shrink-0 [&_path]:fill-can-midnight-steel ml-auto" />
      ) : null}
    </h2>
  );

  if (disabled) {
    return (
      <div className="w-full bg-white flex items-center justify-between opacity-60">
        {cardContent}
      </div>
    );
  }

  return (
    <SearchParamsLink
      className="w-full bg-white flex items-center justify-between"
      onMouseDown={() => {
        trackMarketplaceItemClick({
          id,
        });
      }}
      to={to}
    >
      {cardContent}
    </SearchParamsLink>
  );
};

export { NavigationCard };
